// =============================================
// BIJLEEX — INDEX PAGE JS
// =============================================

// ---- ENERGY FLOW CANVAS ----
const canvas = document.getElementById('energyCanvas');
if (canvas) {
  const ctx = canvas.getContext('2d');
  let W, H, particles = [], nodes = [], bolts = [];

  function resize() {
    W = canvas.width = window.innerWidth;
    H = canvas.height = window.innerHeight;
    initNodes();
  }
  window.addEventListener('resize', resize, { passive: true });

  function initNodes() {
    nodes = [];
    const count = Math.floor(W * H / 40000);
    for (let i = 0; i < count + 6; i++) {
      nodes.push({
        x: Math.random() * W,
        y: Math.random() * H,
        vx: (Math.random() - 0.5) * 0.3,
        vy: (Math.random() - 0.5) * 0.3,
        r: Math.random() * 2 + 1,
        alpha: Math.random() * 0.5 + 0.1
      });
    }
  }

  // Flowing energy particles along the canvas
  function initParticles() {
    particles = [];
    for (let i = 0; i < 60; i++) {
      particles.push({
        x: Math.random() * W,
        y: Math.random() * H,
        vx: (Math.random() - 0.5) * 1.5,
        vy: -(Math.random() * 1 + 0.3),
        alpha: Math.random() * 0.6 + 0.1,
        size: Math.random() * 2 + 0.5,
        hue: 80 + Math.random() * 30 // lime-green range
      });
    }
  }

  function updateParticle(p) {
    p.x += p.vx;
    p.y += p.vy;
    p.alpha -= 0.003;
    if (p.alpha <= 0 || p.y < 0 || p.x < 0 || p.x > W) {
      p.x = Math.random() * W;
      p.y = H + 10;
      p.vx = (Math.random() - 0.5) * 1.5;
      p.vy = -(Math.random() * 1 + 0.3);
      p.alpha = Math.random() * 0.5 + 0.2;
    }
  }

  // Random lightning bolt
  function spawnBolt() {
    const x1 = Math.random() * W;
    const y1 = Math.random() * H * 0.5;
    const segs = Math.floor(Math.random() * 5) + 4;
    const pts = [{ x: x1, y: y1 }];
    for (let i = 1; i <= segs; i++) {
      pts.push({
        x: pts[i-1].x + (Math.random() - 0.5) * 80,
        y: pts[i-1].y + Math.random() * 60 + 20
      });
    }
    bolts.push({ pts, life: 1, decay: 0.05 + Math.random() * 0.05 });
  }

  let boltTimer = 0;
  function drawBolts() {
    boltTimer++;
    if (boltTimer > 80) {
      if (Math.random() < 0.5) spawnBolt();
      boltTimer = 0;
    }
    bolts = bolts.filter(b => b.life > 0);
    bolts.forEach(b => {
      ctx.beginPath();
      ctx.moveTo(b.pts[0].x, b.pts[0].y);
      for (let i = 1; i < b.pts.length; i++) {
        ctx.lineTo(b.pts[i].x, b.pts[i].y);
      }
      ctx.strokeStyle = `rgba(184,255,0,${b.life * 0.4})`;
      ctx.lineWidth = 1;
      ctx.shadowBlur = 8;
      ctx.shadowColor = '#b8ff00';
      ctx.stroke();
      ctx.shadowBlur = 0;
      b.life -= b.decay;
    });
  }

  const MAX_DIST = 140;
  function draw() {
    ctx.clearRect(0, 0, W, H);

    // Update & draw nodes
    nodes.forEach(n => {
      n.x += n.vx; n.y += n.vy;
      if (n.x < 0 || n.x > W) n.vx *= -1;
      if (n.y < 0 || n.y > H) n.vy *= -1;

      ctx.beginPath();
      ctx.arc(n.x, n.y, n.r, 0, Math.PI * 2);
      ctx.fillStyle = `rgba(184,255,0,${n.alpha})`;
      ctx.fill();
    });

    // Draw connecting lines
    for (let i = 0; i < nodes.length; i++) {
      for (let j = i + 1; j < nodes.length; j++) {
        const dx = nodes[i].x - nodes[j].x;
        const dy = nodes[i].y - nodes[j].y;
        const dist = Math.sqrt(dx * dx + dy * dy);
        if (dist < MAX_DIST) {
          const alpha = (1 - dist / MAX_DIST) * 0.15;
          ctx.beginPath();
          ctx.moveTo(nodes[i].x, nodes[i].y);
          ctx.lineTo(nodes[j].x, nodes[j].y);
          ctx.strokeStyle = `rgba(184,255,0,${alpha})`;
          ctx.lineWidth = 0.5;
          ctx.stroke();
        }
      }
    }

    // Flowing energy particles
    particles.forEach(p => {
      updateParticle(p);
      ctx.beginPath();
      ctx.arc(p.x, p.y, p.size, 0, Math.PI * 2);
      ctx.fillStyle = `hsla(${p.hue},100%,60%,${p.alpha})`;
      ctx.fill();
    });

    drawBolts();
    requestAnimationFrame(draw);
  }

  resize();
  initParticles();
  draw();
}

// ---- COUNTDOWN TIMER ----
const countdownWrap = document.querySelector('.countdown-wrap');
if (countdownWrap) {
  const launchDate = new Date(countdownWrap.dataset.launchDate || '2026-09-01T00:00:00+01:00').getTime();
  const countdownEls = {
    days: document.getElementById('days'),
    hours: document.getElementById('hours'),
    minutes: document.getElementById('minutes'),
    seconds: document.getElementById('seconds')
  };

  function updateCountdown() {
    const now = Date.now();
    const diff = launchDate - now;
    const pad = n => String(Math.max(0, n)).padStart(2, '0');

    if (diff <= 0) {
      Object.values(countdownEls).forEach(el => { if (el) el.textContent = '00'; });
      return;
    }

    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diff % (1000 * 60)) / 1000);

    if (countdownEls.days) countdownEls.days.textContent = pad(days);
    if (countdownEls.hours) countdownEls.hours.textContent = pad(hours);
    if (countdownEls.minutes) countdownEls.minutes.textContent = pad(minutes);
    if (countdownEls.seconds) countdownEls.seconds.textContent = pad(seconds);
  }

  setInterval(updateCountdown, 1000);
  updateCountdown();
}

// ---- NOTIFY FORM ----
function handleNotify(e) {
  e.preventDefault();
  const form = e.target;
  form.style.display = 'none';
  const success = document.getElementById('notifySuccess');
  if (success) success.classList.add('show');
}
